"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _MobileNav = require("./MobileNav.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var MenuToggleButtonJs = function MenuToggleButtonJs(_ref) {
  var toggleButtonId = _ref.toggleButtonId,
    open = _ref.open,
    handleModalControl = _ref.handleModalControl;
  return /*#__PURE__*/_react.default.createElement(_MobileNav.ControlButton, {
    "aria-controls": toggleButtonId,
    "aria-expanded": open ? 'true' : 'false',
    "aria-haspopup": "true",
    "aria-label": "Toggle Mobile Navigation",
    "data-key": "max-top-nav--mobile__menu-toggle",
    onClick: handleModalControl
  }, /*#__PURE__*/_react.default.createElement(_MobileNav.Line, {
    open: open
  }), /*#__PURE__*/_react.default.createElement(_MobileNav.Line, {
    open: open
  }), /*#__PURE__*/_react.default.createElement(_MobileNav.Line, {
    open: open
  }));
};
var _default = MenuToggleButtonJs;
exports.default = _default;